import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import '../index.css';

const Onboarding = ({ onComplete }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState('welcome'); // 'welcome', 'newsletter', 'avatar'
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [selectedAvatar, setSelectedAvatar] = useState('');
  const [selectedAvatarName, setSelectedAvatarName] = useState('');
  const [blinking, setBlinking] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [logoClickCount, setLogoClickCount] = useState(0);
  const [logoClickTimer, setLogoClickTimer] = useState(null);

  const avatars = [
    { name: 'Brian', emoji: '🏌️' },
    { name: 'Drake', emoji: '👨' },
    { name: 'Noen', emoji: '🧔' },
    { name: 'Jeremy', emoji: '👱' },
    { name: 'Golf Jesus', emoji: '⛳' },
    { name: 'Joey', emoji: '😎' },
    { name: 'Nelly', emoji: '👩' },
    { name: 'Kendahl', emoji: '👧' },
    { name: 'Alexis', emoji: '👩\u200D🦰' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setBlinking(prev => !prev);
    }, 600);
    return () => clearInterval(interval);
  }, []);

  const handleStart = () => {
    setStep('newsletter');
  };

  const handleNewsletterSubmit = async () => {
    if (fullName.trim() && email.trim() && fullName.length <= 20) {
      setSubmitting(true);
      try {
        // Subscribe to newsletter
        await api.newsletterSubscribe(fullName, email);
        
        // Authenticate/create user profile
        const user = await api.userLogin(fullName, email);
        
        // Store user in localStorage
        localStorage.setItem('loop_user', JSON.stringify(user));
        
        setStep('avatar');
      } catch (error) {
        console.error('Error:', error);
        // Still proceed even if errors occur
        setStep('avatar');
      } finally {
        setSubmitting(false);
      }
    }
  };

  const handleAvatarSelect = (avatar) => {
    setSelectedAvatar(avatar.emoji);
    setSelectedAvatarName(avatar.name);
  };

  const handleStartGame = async () => {
    if (selectedAvatarName) {
      // Fire-and-forget: record this player selection for analytics.
      // Don't block onComplete if the call fails.
      try {
        api.recordPlayerSelection(selectedAvatarName, selectedAvatar, fullName || null, email || null);
      } catch (e) {
        // swallow
      }
      onComplete(fullName || 'PLAYER', selectedAvatar);
    }
  };

  const handleLogoClick = () => {
    setLogoClickCount(prev => prev + 1);
    
    // Clear existing timer
    if (logoClickTimer) {
      clearTimeout(logoClickTimer);
    }
    
    // Set new timer to reset click count after 1 second
    const timer = setTimeout(() => {
      setLogoClickCount(0);
    }, 1000);
    
    setLogoClickTimer(timer);
    
    // Check if triple-clicked
    if (logoClickCount + 1 === 3) {
      setLogoClickCount(0);
      navigate('/admin');
    }
  };

  return (
    <div className="crt" style={{ minHeight: '100vh', background: '#0a0a0a', color: '#00ff00', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
      {step === 'welcome' && (
        <div style={{ textAlign: 'center', width: '100%', maxWidth: '600px' }}>
          <div 
            onClick={handleLogoClick}
            style={{ 
              marginBottom: '40px', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              cursor: 'pointer',
              userSelect: 'none'
            }}
          >
            <img 
              src="/logo.png" 
              alt="Blue Heron" 
              style={{ 
                width: '120px', 
                height: '120px', 
                imageRendering: 'pixelated', 
                display: 'block',
                pointerEvents: 'none'
              }} 
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#FFC857', fontSize: '16px', letterSpacing: '0.2em' }}>★ WELCOME TO ★</span>
          </div>
          
          <h1 style={{ fontSize: '48px', color: '#4AE54A', marginBottom: '10px', fontFamily: 'Press Start 2P, monospace', lineHeight: '1.4' }}>THE LOOP</h1>
          
          <p style={{ color: '#FEFEE3', fontSize: '14px', marginBottom: '60px', letterSpacing: '0.15em' }}>GOLF APPAREL CO.</p>
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginBottom: '60px' }}>
            <span style={{ fontSize: '32px' }}>🏌️</span>
            <span style={{ fontSize: '32px' }}>⛳</span>
            <span style={{ fontSize: '32px' }}>🏌️</span>
            <span style={{ fontSize: '32px' }}>⛳</span>
            <span style={{ fontSize: '32px' }}>🏌️</span>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <p style={{ color: '#FFC857', fontSize: '18px', letterSpacing: '0.2em' }}>— INSERT COIN —</p>
            <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>CREDIT: 99</p>
          </div>
          
          <button 
            onClick={handleStart}
            className={blinking ? '' : ''}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#4AE54A', 
              fontSize: '20px', 
              fontFamily: 'Press Start 2P, monospace',
              cursor: 'pointer',
              marginTop: '40px',
              opacity: blinking ? 1 : 0.3,
              transition: 'opacity 0.1s'
            }}
          >
            ▶ PRESS START ◀
          </button>
          
          <p style={{ color: '#555', fontSize: '10px', marginTop: '80px' }}>© 2025 THE LOOP GOLF</p>
        </div>
      )}

      {step === 'newsletter' && (
        <div style={{ textAlign: 'center', width: '100%', maxWidth: '600px' }}>
          <h2 style={{ color: '#4AE54A', fontSize: '28px', marginBottom: '30px', fontFamily: 'Press Start 2P, monospace', lineHeight: '1.4' }}>ENTER NAME</h2>
          <p style={{ color: '#FFC857', fontSize: '14px', marginBottom: '30px', letterSpacing: '0.1em' }}>MAX 20 CHARACTERS</p>
          
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value.toUpperCase())}
            maxLength={20}
            className="retro-input"
            style={{ 
              background: '#000', 
              border: '4px solid #4AE54A', 
              color: '#4AE54A', 
              fontSize: '24px', 
              padding: '20px', 
              width: '100%',
              fontFamily: 'IBM Plex Mono, monospace',
              textAlign: 'center',
              boxShadow: '0 0 20px rgba(74, 229, 74, 0.3)',
              marginBottom: '30px'
            }}
            placeholder="YOUR NAME"
            autoFocus
          />
          
          <h3 style={{ color: '#4AE54A', fontSize: '20px', marginBottom: '20px', fontFamily: 'Press Start 2P, monospace', lineHeight: '1.4' }}>ENTER EMAIL</h3>
          <p style={{ color: '#FFC857', fontSize: '12px', marginBottom: '20px', letterSpacing: '0.1em' }}>JOIN THE LOOP NEWSLETTER</p>
          
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="retro-input"
            style={{ 
              background: '#000', 
              border: '4px solid #4AE54A', 
              color: '#4AE54A', 
              fontSize: '18px', 
              padding: '18px', 
              width: '100%',
              fontFamily: 'IBM Plex Mono, monospace',
              textAlign: 'center',
              boxShadow: '0 0 20px rgba(74, 229, 74, 0.3)',
              marginBottom: '40px'
            }}
            placeholder="YOUR@EMAIL.COM"
          />
          
          <button
            onClick={handleNewsletterSubmit}
            disabled={!fullName.trim() || !email.trim() || submitting}
            className="retro-btn"
            style={{ 
              background: '#2C6E49', 
              border: '4px solid #4AE54A',
              color: '#FEFEE3', 
              padding: '18px 60px',
              fontSize: '16px',
              fontFamily: 'Press Start 2P, monospace',
              opacity: (fullName.trim() && email.trim() && !submitting) ? 1 : 0.5,
              cursor: (fullName.trim() && email.trim() && !submitting) ? 'pointer' : 'not-allowed',
              boxShadow: '0 0 20px rgba(74, 229, 74, 0.2)'
            }}
          >
            {submitting ? 'LOADING...' : 'CONTINUE >>>'}
          </button>
        </div>
      )}

      {step === 'avatar' && (
        <div style={{ textAlign: 'center', width: '100%', maxWidth: '520px', padding: '0 10px', boxSizing: 'border-box' }}>
          <h2 style={{ color: '#4AE54A', fontSize: 'clamp(16px, 5vw, 24px)', marginBottom: '24px', fontFamily: 'Press Start 2P, monospace', letterSpacing: '2px' }}>SELECT PLAYER</h2>

          <div
            data-testid="select-player-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px',
              marginBottom: '28px',
              width: '100%'
            }}
          >
            {avatars.map((avatar) => {
              const isSelected = selectedAvatarName === avatar.name;
              return (
                <button
                  type="button"
                  key={avatar.name}
                  onClick={() => handleAvatarSelect(avatar)}
                  data-testid={`avatar-${avatar.name.toLowerCase().replace(/\s+/g, '-')}`}
                  aria-pressed={isSelected}
                  style={{
                    cursor: 'pointer',
                    padding: '10px 6px',
                    border: `3px solid ${isSelected ? '#4AE54A' : '#333'}`,
                    background: isSelected ? '#1a3a1a' : '#000',
                    transition: 'border-color 150ms, background-color 150ms, box-shadow 150ms',
                    boxShadow: isSelected ? '0 0 16px #4AE54A' : 'none',
                    aspectRatio: '1 / 1',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '92px',
                    fontFamily: 'inherit',
                    color: 'inherit',
                    outline: 'none'
                  }}
                >
                  <span style={{ fontSize: 'clamp(28px, 8vw, 42px)', marginBottom: '4px', lineHeight: 1, pointerEvents: 'none' }}>{avatar.emoji}</span>
                  <span style={{
                    color: isSelected ? '#4AE54A' : '#FFC857',
                    fontSize: 'clamp(8px, 2.2vw, 10px)',
                    margin: 0,
                    letterSpacing: '1px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                    pointerEvents: 'none'
                  }}>{avatar.name.toUpperCase()}</span>
                </button>
              );
            })}
          </div>

          <button
            onClick={handleStartGame}
            disabled={!selectedAvatarName}
            data-testid="start-game-btn"
            className="retro-btn"
            style={{
              background: '#2C6E49',
              color: '#FEFEE3',
              padding: '14px 32px',
              fontSize: 'clamp(11px, 3vw, 14px)',
              opacity: selectedAvatarName ? 1 : 0.5,
              cursor: selectedAvatarName ? 'pointer' : 'not-allowed',
              letterSpacing: '2px'
            }}
          >
            ▶ START GAME ◀
          </button>
        </div>
      )}
    </div>
  );
};

export default Onboarding;
